import React from 'react';
import { CURRENT_PRODUCT_MODE } from '@utils/constants';

interface RFPProps {
  app: string;
  children: JSX.Element;
  fallback?: JSX.Element | null;
}

function RenderForProductHoc({ app, children, fallback = null }: RFPProps) {
  if (app === CURRENT_PRODUCT_MODE) {
    return children;
  }
  return fallback;
}

export const RenderForAI = (props) => <RenderForProductHoc app="AI" {...props} />;

export const RenderForEI = (props) => <RenderForProductHoc app="EI" {...props} />;

export default RenderForProductHoc;
